import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import './loader.styles.scss';
import cn from 'classnames';
import { memo } from 'react';

interface LoaderProps {
    size?: 'small' | 'default';
    variant?: 'primary' | 'black';
}

const Loader = memo(function Loader(props: LoaderProps) {
    const { variant = 'primary', size = 'default' } = props;

    return (
        <Spin
            indicator={
                <LoadingOutlined
                    style={{ fontSize: 24 }}
                    spin
                    id={'loading-icon'}
                    className={cn(variant, size)}
                />
            }
        />
    );
});

Spin.setDefaultIndicator(<Loader />);

export { Loader };
